import { TableCell, makeStyles } from "@material-ui/core";

import React from "react";
import theme from "../../../theme";

const useStyles = makeStyles(() => ({
  head: {
    width: 34,
    textAlign: "center",
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
}));

const MonthColumns = ({ months }) => {
  const classes = useStyles();

  return months?.map((month, index) => (
    <TableCell classes={classes} key={index}>
      {month}
    </TableCell>
  ));
};
export default MonthColumns;
